import { Observable } from 'rxjs';
import { AppLang } from '../../core/lang.service';
import { Banner } from '../models/catalog/banner.model';
import { Catalog } from '../models/catalog/catalog.model';
import { Promos } from '../models/catalog/promo.model';
import { StockSnapshot } from '../models/catalog/stock.model';

/** Каталог организации приходит целиком одним запросом; фильтрация по категории и поиску — клиентская. */
export abstract class CatalogApi {
  /** `lang` выбирает `name`/`nameRu` при маппинге: сервер шлёт обе локали в одном ответе. */
  abstract getCatalog(lang: AppLang): Observable<Catalog>;
  /** Отдельный запрос: баннеры не критичны для заказа и главную задерживать не должны. */
  abstract getBanners(lang: AppLang): Observable<Banner[]>;
  /** Отдельно от `getCatalog`: каталог кешируется на сессию, остаток меняется с каждой продажей. */
  abstract getRemains(): Observable<StockSnapshot>;
  /** По филиалу и без кэша: вторая волна после позиций, ошибка — меню без скидок. */
  abstract getPromos(branchId: string): Observable<Promos>;
}
